module.exports = __webpack_public_path__ + "img/step_0.17857fd5.png";